export default {
  box: {
    width: '34em',
    height: '100%',
    paddingBottom: '4em',
  },
  image: {
    borderRadius: '1em',
    overflow: 'hidden',
    heigth: '9em',
    width: '34em',
  },
  headline: {
    padding: '2em 3em',
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1em',
  },
  action: {
    paddingBottom: '4em',
  },
  optionalLink: {
    textAlign: 'center',
  },
};
